import * as types from '@/store/types';
import { ILoginAlertsModel } from '@/entities';
import alertsApi from '@/api/alerts.api';
import Vue from 'vue';

type AlertType = 'common' | 'account';

export interface UIAlertInfo {
    visible: boolean;
    content: string;
    contentType: 'text' | 'html';
}

interface IAlertWithReadFlag {
    type: AlertType;
    html: string;
    isRead?: boolean;
}

interface State {
    account: IAlertWithReadFlag;
    common: IAlertWithReadFlag;
}

const ALERT_STATE_KEY = 'alert-state';

const initialState = {
    account: null,
    common: null
};

function getVisibleType(state: State) {
    if (isVisible(state.account)) {
        return state.account.type;
    } else if (isVisible(state.common)) {
        return state.common.type;
    } else {
        return null;
    }
}

function isVisible(alert?: IAlertWithReadFlag) {
    return alert && alert.html && !alert.isRead;
}

const getters = {
    [types.ALERT_GET_UI_INFO]: (state: State) => {
        const type = getVisibleType(state);
        switch (type) {
            case 'account':
                return {
                    visible: true,
                    content: state[type].html,
                    contentType: 'text'
                };
            case 'common':
                return {
                    visible: true,
                    content: state[type].html,
                    contentType: 'html'
                };
            default:
                return {
                    visible: false
                };
        }
    }
};

const mutations = {
    [types.ALERT_MARK_AS_READ]: (state: State) => {
        const curType = getVisibleType(state);
        if (curType) {
            Vue.set(state, curType, { ...state[curType], isRead: true });
            // state[curType].isRead = true;
            localStorage.setItem(ALERT_STATE_KEY, JSON.stringify(state));
        }
    },
    [types.ALERT_SET]: (state: State, payload: ILoginAlertsModel) => {
        state.account = { html: payload.accountAlert, type: 'account' };
        state.common = { html: payload.commonAlert, type: 'common' };
        localStorage.setItem(ALERT_STATE_KEY, JSON.stringify(state));
    }
};

const actions = {
    [types.ALERT_LOAD_LOGIN_ALERT]: ({ commit }) => {
        alertsApi.loginAlerts().then((res: ILoginAlertsModel) => {
            //  document.body.classList.add('no-scroll');
            commit(types.ALERT_SET, res);
        });
    },
    [types.ALERT_MARK_AS_READ]: ({ commit }, payload: AlertType) => {
        //  document.body.classList.remove('no-scroll');
        commit(types.ALERT_MARK_AS_READ, payload);
    }
};

const savedState = localStorage.getItem(ALERT_STATE_KEY);

export default {
    state: savedState ? JSON.parse(savedState) : initialState,
    mutations,
    actions,
    getters
};
